import { isEmpty } from '@ember/utils'
import type StudentEventsService from 'district-ui-client/services/student-events'
import type { StatsScope } from 'district-ui-client/utils/student-events/stats-scope'
import type { NormalizedInterval } from 'date-fns'

export interface AssessmentScoresResponse {
  assessment_scores: {
    average_score: Nullable<number>
    average_attempts: number
    scores: [
      { range: '0-49'; student_count: number },
      { range: '50-79'; student_count: number },
      { range: '80-100'; student_count: number },
    ]
  }
}

export type AssessmentScoresData = AssessmentScoresResponse['assessment_scores']

export async function assessmentScores(
  this: StudentEventsService,
  product: LegacyProductMs | LegacyProductRe | LegacyProductRex,
  statsScope: StatsScope,
  period: NormalizedInterval,
): Promise<Nullable<AssessmentScoresData>> {
  if (isEmpty(statsScope.ids)) return null

  const url = this.buildUrl('assessment_scores', product, statsScope)
  const query = this.buildQuery(statsScope, period)

  const data = await this.fetchData<AssessmentScoresResponse>(url, query)
  if (!data) return null

  const { assessment_scores } = data
  const noStudents = assessment_scores.scores.every((row) => row.student_count === 0)
  if (noStudents) {
    return null
  }

  return assessment_scores
}
